import { render, staticRenderFns } from "./MileageDetail.vue?vue&type=template&id=dab107a0&scoped=true&"
import script from "./MileageDetail.vue?vue&type=script&lang=js&"
export * from "./MileageDetail.vue?vue&type=script&lang=js&"
import style0 from "./MileageDetail.vue?vue&type=style&index=0&id=dab107a0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dab107a0",
  null
  
)

export default component.exports